import { render, staticRenderFns } from "./number-list.vue?vue&type=template&id=470866bf&lang=pug&"
import script from "./number-list.vue?vue&type=script&lang=js&"
export * from "./number-list.vue?vue&type=script&lang=js&"
import style0 from "./number-list.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports